import { domel } from '@easydata/ui';
import { browserUtils } from '../../../utils/browser_utils';
var TextRenderer = /** @class */ (function () {
    function TextRenderer(panel, text, slot) {
        this.panel = panel;
        this.text = text;
        this.element = slot || domel('div').toDOM();
    }
    Object.defineProperty(TextRenderer.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-qp';
        },
        enumerable: true,
        configurable: true
    });
    TextRenderer.prototype.refresh = function () {
        this.render();
    };
    TextRenderer.prototype.render = function () {
        var _this = this;
        domel(this.element)
            .html('')
            .addClass(this.getClassesToAdd())
            .addClass(browserUtils.getMobileCssClass())
            .addChild('span', function (builder) { return builder
            .text(_this.text)
            .title(_this.text); })
            .toDOM();
        return this.element;
    };
    TextRenderer.prototype.getClassesToAdd = function () {
        return this.cssPrefix + "-condelement";
    };
    return TextRenderer;
}());
export { TextRenderer };
//# sourceMappingURL=text_renderer.js.map